// extracted by mini-css-extract-plugin
export default {"checkboxGroup":"SafetySettingsForm_checkboxGroup__a1eKu","subTitle":"SafetySettingsForm_subTitle__Qpf8x","extraPadding":"SafetySettingsForm_extraPadding__OWkEn"};